import { format, isValid, parse } from 'date-fns'

const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/

export function isCalendarDate(value: string | null): value is string {
  return !!value && CALENDAR_DATE.test(value) && isValid(parse(value, 'yyyy-MM-dd', new Date()))
}

export function calendarDateToDate(value: string): Date {
  return parse(value, 'yyyy-MM-dd', new Date())
}

export function dateToCalendarDate(date: Date): string {
  return format(date, 'yyyy-MM-dd')
}
